import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import MainMenu from '../MainMenu/MainMenu';
import * as headerAction from '../../../../actionCreators/header';
import { Link } from 'react-router-dom';
import './Nav.scss';
// import './Navigation.scss';

class Navigation extends Component {

    static propTypes = {
        navData: PropTypes.object,
        headerAction: PropTypes.object.isRequired,
        isMenuVisible: PropTypes.bool.isRequired,
    }

    constructor(props) {
        super(props);
    }

    componentDidUpdate() {
        // This fix is hide the menu/submenu when user click on any of the menu/submenu.
        if (!this.props.isMenuVisible) {
            this.props.headerAction.rerenderMenu(true);
        }
    }
    updateNavDtm = (type, section, subSection, link, cta) => {
        this.props.headerAction.rerenderMenu(false);
        if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.header.click.topNavClick(type, section, subSection, link, cta);
    }

    updateNavValueDtm = (type, section, subSection, link) => {
        this.props.headerAction.rerenderMenu(false);
        if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.header.click.topNavClickValue(type, section, subSection, link);
    }
    // toggleMenu = value => {
    //     this.props.headerAction.rerenderMenu(value);
    // }

    render() {
        const { navData, rightNavData, location } = this.props;
        return (
            <div className="no-padding navigation"> { /* ${(isMenuHidden ? 'hide' : '')} */}
                <nav className="navigation_top layout center">
                    <div className="layout justify-content-between navigation-list">
                        {this.props.isMenuVisible && <MainMenu navData={navData} updateNavValueDtm={this.updateNavValueDtm} updateNavDtm={this.updateNavDtm} location={location} />}
                    </div>
                    <div className="layout justify-content-between navigation_right">
                        {rightNavData && rightNavData.map((rigtNav, index) => {
                            return (<div key={index}>
                                {rigtNav.url && rigtNav.url.indexOf('lenskart.com') === -1 ?
                                    <Link to={rigtNav.url}>
                                        <div className="img-wrapper">
                                            <img alt={rigtNav.alt} src={rigtNav.src} />
                                        </div>
                                    </Link> :
                                    <a href={rigtNav.url} className="" onClick={() => this.updateNavDtm(rigtNav, rightNavData, null, null, rigtNav.cta)}>
                                        <div className="img-wrapper">
                                            <img alt={rigtNav.alt} src={rigtNav.src} />
                                        </div>
                                    </a>
                                }</div>);
                        })
                        }
                    </div>
                </nav>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    isMenuVisible: state.header.isMenuVisible
});

function mapDispatchToProps(dispatch) {
    return {
        headerAction: bindActionCreators(headerAction, dispatch)
    };
}

Navigation.defaultProps = {
    navData: {}
};

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);
